module.exports = __webpack_public_path__ + "img/appBack3.5787714a.png";